import React from 'react'
import Dropzone from 'react-dropzone'
import { Alert, Button, Form, FormGroup, Input } from 'reactstrap'
const myImage = require('assets/img/avatar.png')

export default ({
  onDropAccepted,
  onDropRejected,
  onChange,
  firstName,
  lastName,
  onClick,
  currentUser,
  imgPath,
  err,
  buttonText,
}) => (
  <Form>
    <FormGroup>
      <Dropzone
        multiple={false}
        className="avatar"
        onDropAccepted={onDropAccepted}
        onDropRejected={onDropRejected}
        accept="image/jpeg, image/png, image/gif, image/jpg"
        name="avatar"
      >
        <img
          src={(currentUser && currentUser.avatar) || imgPath}
          className="rounded-circle img-thumbnail"
          alt="avatar"
        />
      </Dropzone>
      {err && err.imgErr && <Alert color="danger">{err.imgErr}</Alert>}
    </FormGroup>
    <FormGroup>
      <Input
        type="text"
        onChange={onChange}
        name="firstName"
        placeholder="Имя"
        value={firstName}
      />
    </FormGroup>
    <FormGroup>
      <Input
        type="text"
        onChange={onChange}
        name="lastName"
        placeholder="Фамилия"
        value={lastName}
      />
    </FormGroup>
    {err && err.emptyErr && <Alert color="danger">{err.emptyErr}</Alert>}
    <Button onClick={onClick} color="warning" block>
      {buttonText}
    </Button>
  </Form>
)



// WEBPACK FOOTER //
// ./src/components/forms/SettingsForm.js